import Icon from '@/components/icon';
import useScroll from '@/hooks/use-scroll.hook';
import { Box, Theme } from '@mui/material';
import { FC, useCallback } from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme: Theme) => ({
  followButton: {
    position: 'absolute',
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[200],
    color: theme.palette.divider,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '50%',
    height: 26,
    right: 30,
    bottom: 5,
    cursor: 'pointer',
    opacity: 0.6,
    hover: {
      opacity: 1,
    },
    padding: 4,
  },
}));

const FollowButton: FC = () => {
  const styles = useStyles();

  const { atBottom, scrollToBottom, tailing } = useScroll();
  const handleClick = useCallback(() => {
    scrollToBottom();
  }, [scrollToBottom]);

  if (atBottom || tailing) {
    return null;
  }

  return (
    <Box className={styles.followButton}>
      <Icon name="arrow-down" onClick={handleClick} size="small" />
    </Box>
  );
};

export default FollowButton;
